import { useSyncExternalStore } from "react";
import sharedDatas from "../sharedDatas";
import { getEffectiveAreaPermission } from "../helpers/licenseHelpers";

const subscribe = (listener) => sharedDatas.subscribe(listener);
const readPermissions = () => sharedDatas.getPropertyByName("userPermissions");
const readTenant = () => sharedDatas.getPropertyByName("tenantModel");
const readAziendaId = () => sharedDatas.getPropertyByName("aziendaId");

export const useAreaPermissions = (area) => {
    const userPermissions = useSyncExternalStore(subscribe, readPermissions);
    const tenant = useSyncExternalStore(subscribe, readTenant);
    const aziendaId = useSyncExternalStore(subscribe, readAziendaId);

    return {
        permissions: getEffectiveAreaPermission(userPermissions, tenant, area, aziendaId),
        getPermissions: () => getEffectiveAreaPermission(readPermissions(), readTenant(), area, readAziendaId()),
    };
};